import { inject } from '@angular/core'
import { Dialog } from '@angular/cdk/dialog'
import { CanActivateChildFn, Router } from '@angular/router'
import { catchError, map, of } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { DialogService } from '../services/dialog.service'
import { ErrorService } from '../services/error.service'
import { ProductService } from '../services/product.service'
import { TranslationService } from '../services/translation.service'

/**
 * Checks access before loading the full product pages. Marketplace visibility
 * does not grant company access, so show a dialog when a share is required.
 */
export const productAccessGuard: CanActivateChildFn = (route) => {
  const router = inject(Router)
  if (!inject(AuthService).isLoggedIn()) {
    return router.createUrlTree(['/auth', 'login'])
  }

  const productService = inject(ProductService)
  const dialog = inject(Dialog)
  const dialogService = inject(DialogService)
  const errorService = inject(ErrorService)
  const translationService = inject(TranslationService)
  const redirect = router.createUrlTree(['/marketplace'])

  return productService.getAccess(route.parent!.paramMap.get('id')!).pipe(
    map((access) => {
      if (access.canViewDetails) return true

      dialogService.showDialog(
        dialog,
        translationService.getErrorText(),
        translationService.getProductDetailsRestrictedText(),
      )
      return redirect
    }),
    catchError((err) => {
      errorService.handleErr(dialogService, err, dialog)
      return of(redirect)
    }),
  )
}
